import React from 'react'
import PropTypes from 'prop-types'

import ToastLogo from '../../assets/powered-by/grey-horizontal.svg'

import Modal from '../Modal/Modal'

import './PoweredByToastModal.css'

export const PoweredByToastModal = ({ header, children, onClose }) => (
  <Modal
    header={header}
    onClose={onClose}
    footer={<ToastLogo styleName='logo' />}
  >
    <div styleName='modal'>{children}</div>
  </Modal>
)

PoweredByToastModal.propTypes = {
  header: PropTypes.node,
  children: PropTypes.node,
  onClose: PropTypes.func
}
